import { COMMON } from "../../util/localizations";

const TRANSLATIONS = {
    en: {
        4001: 'Transaction failed. User aborted.',
        account: COMMON.en.account,
        cancel: "Cancel",
        confirm: 'Mint',
        etherscan: COMMON.en.etherscan,
        goerliOnly: COMMON.en.goerliOnly,
        instructions: `Clicking the, "{0}" button below will permanently delete this node and all of its connections. You will not be able to undo this action.`,
        invalidBoard: COMMON.en.fileCorrupt,
        mintingTakesTime: 'Minting takes time. You can check the progress of the mint from within MetaMask.',
        network: 'Network',
        noBoardName: 'No board name was provided.',
        notYourAccount: `The selected account doesn't belong to you.`,
        notEnoughGas: 'Mint failed. Not enough gas.',
        successImport: 'Successfully imported CoE',
        successMint: 'Successfully minted token. You can view the transaction on {0}',        
        testNetwork: 'Test Network',
        title: 'Mint, "{0}" as an NFT',
        warning: 'Please read before continuing',
        wrongNetwork: COMMON.en.wrongNetwork,
        ...COMMON.networks
    }
}

export default TRANSLATIONS